import type { Step } from '@de/types/types';
import getTrafficSource from '@de/utils/getTrafficSource';
import { readStepTrafficSource } from './configurable-step/readStepTrafficSource';

/**
 * Step-configured `trafficSource` wins over the landing URL's `utm_cap`
 * value. Returns `undefined` when neither source supplies a non-empty value.
 */
export function resolveTrafficSource(step?: Step): string | undefined {
  const stepValue = readStepTrafficSource(step);
  if (stepValue) {
    return stepValue;
  }
  if (typeof window === 'undefined') {
    return undefined;
  }
  const urlValue = getTrafficSource(window.location?.href ?? '');
  return typeof urlValue === 'string' && urlValue.length > 0
    ? urlValue
    : undefined;
}

/**
 * Conversion payloads default to `organic` when no step or URL value exists.
 */
export function resolveTrafficSourceForConversion(step?: Step): string {
  return resolveTrafficSource(step) ?? 'organic';
}
